import { NavController} from '@ionic/angular';
import { SessionProvider } from '../../providers/session/session';
import { Component } from '@angular/core';
import { TournamentService } from '../apps/gamer/services/tournament.service';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { Router } from '@angular/router';
import { EventsLauncherService } from 'src/providers/events-launcher.service';

@Component({
  templateUrl: 'events-launcher.html',
  selector: 'events-launcher',
  styleUrls:['./events-launcher.scss']
})
export class EventsLauncherPage {
  $loginSub = null;
  $logoutSub = null;
  $planSub = null;
  openNewPage: boolean = false;

  constructor(
    public sessionService: SessionProvider,
    private router:Router,
    public appDetector: AppDetectorProvider,
    private gs: TournamentService,
    public tabsLauncherService: EventsLauncherService,
    public navCtrl:NavController
    ) { }

  onLogin() {
    // (this.app.getRootNav() as NavController).push(LoginPage);
    this.navCtrl.navigateForward('/auth/login');
  }

  onNewTournament(){
    if(!this.sessionService.isLoged){
       this.onLogin();
       this.openNewPage = true;
    }else{
      // (this.app.getRootNav() as NavController).push(this.getNewEventPage());
      this.navCtrl.navigateForward(this.getNewEventPage());
    }
  }

  

  getNewEventPage(){
    if(this.appDetector.isLeaderBoardApp()){
      // return EventCreateTabsPage;
      return '/event/create/create-tabs'
    }else if(this.appDetector.isTournamentApp()){
      // return NewTouMainPage;
      return '/new-tou'
    }
    return '/'
  }

  ngOnInit() {
    if (!this.$loginSub) {
      this.$loginSub = this.sessionService.onRequestLoggedIn().subscribe(() => {
        // (this.app.getRootNav() as NavController).setRoot(TabsPage).then(() => {
        //   if (this.openNewPage) {
        //     (this.app.getRootNav() as NavController).push(this.getNewEventPage());
        //   }
        // })
        this.navCtrl.navigateForward('/tabs').then(() => {
          if (this.openNewPage) {
            const newPageUrl = this.getNewEventPage();
            this.navCtrl.navigateForward(newPageUrl);
          }
        });
      });
    }

    if (!this.$planSub) {
      this.$planSub = this.gs.$planListChangeSub.subscribe(() => {
        // (this.app.getRootNav() as NavController).setRoot(TabsPage);
        this.navCtrl.navigateForward('/tabs');
      });
    }
  }
  
  ngOnDestroy(){
    if(this.$loginSub) {
      this.$loginSub.unsubscribe();
      this.$loginSub = null;
    }
    if(this.$planSub){
      this.$planSub.unsubscribe();
      this.$planSub = null;
    }
  }


}
